/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentQueryFilters {
    getFixupPrototypeFunction() { return AwsSsmDocumentQueryFilters.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentQueryFilters>): AwsSsmDocumentQueryFilters {
        let obj = Object.assign(new AwsSsmDocumentQueryFilters(), model);
        AwsSsmDocumentQueryFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentQueryFilters>): AwsSsmDocumentQueryFilters {
        if (!model) return null;
        return AwsSsmDocumentQueryFilters.newInstance(<AwsSsmDocumentQueryFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentQueryFilters) {
        if (!obj) return;

        models.AwsSsmDocumentQueryFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentQueryFilters): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocumentQueryFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Regions based on the available documents (all if missing)
     */
    regions: Array<string>;

    /**
     * The AWS user that created the document (all if missing)
     */
    owners: Array<string>;

    /**
     * The classification of a document to help you identify and categorize its use (all if missing)
     */
    categories: Array<string>;

}
